import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { VizseekService } from 'src/app/customServices/vizseek.service';
import { KbVizseekNoPopupComponent } from '../kb-vizseek-no-popup/kb-vizseek-no-popup.component';
import { HttpClient } from '@angular/common/http';
import { OccEndpointsService } from '@spartacus/core';
import { Overlay } from '@angular/cdk/overlay';

@Component({
    selector: 'app-kb-vizseek-yes-popup',
    templateUrl: './kb-vizseek-yes-popup.component.html',
    styleUrls: ['./kb-vizseek-yes-popup.component.scss'],
    standalone: false
})
export class KbVizseekYesPopupComponent {
  constructor(private vizseekApi:VizseekService,private router:Router,
    private dialog:MatDialog,private overlay: Overlay ){}

  FeedBack(feedback:string){  
   this.vizseekApi.feedBack(feedback);
     if(feedback=='no'){
      this.router.navigate(['Products/c/NA-000']);
      this.dialog.open(KbVizseekNoPopupComponent,{ scrollStrategy: this.overlay.scrollStrategies.noop(), panelClass: 'custom-dialog-vizseek-container' });  

  }
}
}
